type Props = {
  sources: string;
};

export function useBehaviour({ sources }: Props) {
  return {
    sources,
  };
}
